<template>
  <v-container id="modificadores" tag="section">
    <base-material-card
      color="indigo"
      icon="mdi-basket"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <v-btn color="grey" dark class="mb-2 mr-4" @click="goBack"
          >Volver</v-btn
        >
        <v-btn
          color="success"
          dark
          class="mb-2"
          @click="save"
          :loading="loadingGuardar"
          >Guardar</v-btn
        >
        <!-- <v-btn
          color="info"
          dark
          class="mb-2 ml-4"
          @click="accion = 'configurar'"
          v-if="!isConfigurar"
          >Configurar</v-btn
        > -->
      </v-toolbar>
      <v-row dense class="pa-0">
        <v-col cols="12">
          <v-alert dense type="info" class="black--text">
            Este modificador lo utilizan los grupos
            <strong> {{ gruposUtilizanModificador }}</strong></v-alert
          ></v-col
        >
      </v-row>
      <v-card-text>
        <h3>{{ title }}</h3>
        <v-spacer />
        <v-row align="center">
          <v-col cols="12" md="3">
            <v-btn small color="primary" @click="addOpcionBoton"
              >Añadir Opción</v-btn
            >
          </v-col>
          <!-- <v-col cols="12" md="3">
            <v-btn small color="primary" @click="crearOpcionBoton"
              >Crear Opción</v-btn
            >
          </v-col> -->
          <v-col cols="12" md="6">
            <v-select
              :items="idiomas"
              v-model="langSeleccionado"
              label="Selección idioma"
              outline
            ></v-select>
          </v-col>
        </v-row>
        <v-card elevation="100">
          <v-toolbar color="secondary" dark class="px-4">
            <v-row justify="center" align="center">
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="nombrePanel"
                  :label="nombrePanelLabel"
                  autofocus
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="8">
                <v-text-field
                  v-model="descripcionPanel"
                  :label="descripcionPanelLabel"
                  autofocus
                ></v-text-field>
              </v-col>
            </v-row>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="modificador.descripcionInterna"
                  label="Descripción interna"
                  autofocus
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  :items="tipos"
                  v-model="modificador.tipo"
                  label="Tipo"
                />
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="modificador.max"
                  type="number"
                  :step="1"
                  label="Máximo"
                />
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field
                  type="number"
                  :step="1"
                  v-model="modificador.min"
                  label="Mínimo"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-title>
            Opciones
            <v-icon @click="marcarTodos(false)" class="ml-3"
              >mdi-checkbox-multiple-blank-outline</v-icon
            >

            <v-icon @click="marcarTodos(true)" class="ml-3"
              >mdi-checkbox-multiple-marked-outline</v-icon
            >
          </v-card-title>
          <v-data-table
            ref="sortableTable"
            :items="modificadoresComputed"
            disable-pagination
            hide-default-footer
            :headers="headers"
            :loading="loading"
          >
            <template v-slot:item="{ item }">
              <tr class="sortableRow" :key="itemKey(item)">
                <td class="px-1">
                  <v-row dense justify="center" align="center">
                    <v-row
                      dense
                      align="center"
                      justify="center"
                      class="mb-0 pa-0"
                    >
                      <v-btn
                        text
                        x-small
                        color="red"
                        @click="deleteItem(item)"
                        class="mr-2"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                      <v-btn
                        text
                        x-small
                        color="red"
                        @click="goOpcion(item)"
                        class="mr-2"
                      >
                        <v-icon>mdi-open-in-new</v-icon>
                      </v-btn>
                      <v-checkbox
                        text
                        x-small
                        color="red"
                        @click="marcarDefecto(item)"
                        class="mr-2"
                      >
                      </v-checkbox>
                    </v-row>
                    <v-btn
                      style="cursor: move"
                      icon
                      class="sortHandle mb-1 mt-0"
                      outlined
                      ><v-icon>mdi-drag</v-icon></v-btn
                    ></v-row
                  >
                </td>

                <td>
                  {{ item.nombre }}
                  <h5>{{ item.descripcionInterna }}</h5>
                </td>
                <template v-for="(t, i) in tarifas">
                  <td
                    :key="`activo_${i}`"
                    :class="colores[i % 6] + ' lighten-4'"
                  >
                    <v-checkbox
                      v-model="item.tarifas[i].activo"
                      dense
                      @change="
                        cambiarAsociadoCheckBox($event, item, item.tarifas[i])
                      "
                    />
                  </td>
                  <td
                    :key="`precio_${i}`"
                    :class="colores[i % 6] + ' lighten-4'"
                  >
                    <v-text-field
                      dense
                      type="number"
                      step="0.5"
                      v-model="item.tarifas[i].precio"
                    />
                  </td>
                </template>
              </tr>
            </template>
            <template v-for="t in tarifas" v-slot:item[t.id]="{ item }">
              <td>{{ item }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-card-text>
      <v-dialog v-model="dialogAddOpcion" max-width="300">
        <v-card>
          <v-card-title>Añadir Opción</v-card-title>
          <v-card-text>
            {{ opcionAdd }}
            <v-autocomplete
              ref="addOpcionNombre"
              :search-input.sync="search"
              v-model="opcionAdd"
              :items="modificadores"
              @change="addOpcionConfirmar"
              @keydown.enter="
                dialogCrearOpcion = true;
                dialogAddOpcion = false;
                crearOpcion.nombre = search;
              "
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      Pulse <kbd>enter</kbd> para crear
                      <strong>{{ search }}</strong>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-autocomplete>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn small color="success" @click="addOpcionConfirmar()"
              >Añadir</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogCrearOpcion" max-width="300">
        <v-card>
          <v-card-title>Crear Opción</v-card-title>
          <v-card-text>
            <v-text-field
              @keydown.enter="crearOpcionConfirmar"
              ref="crearOpcionNombre"
              v-model="crearOpcion.nombre"
              label="Nombre del idioma por defecto"
              messages="El resto de idiomas se generará vacío"
            />
            <v-text-field
              v-model="crearOpcion.descripcion"
              @keydown="crearOpcionConfirmar"
              label="Descripción del idioma por defecto"
              messages="El resto de idiomas se generará vacío"
            />
            <v-text-field
              @keydown="crearOpcionConfirmar"
              v-model="crearOpcion.descripcionInterna"
              label="Descripción interna"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              small
              color="success"
              @click="crearOpcionConfirmar"
              :loading="crearOpcion.loading"
              >Añadir</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </base-material-card>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { mostrarIdioma } from "@/utils/utils.js";
import draggable from "vuedraggable";
import Sortable from "sortablejs";
export default {
  data() {
    return {
      search: "",
      itemKeys: new WeakMap(),
      currentItemKey: 0,
      loadingGuardar: false,
      loading: false,
      colores: ["yellow", "red", "blue", "purple", "green", "pink"],
      dialogAddOpcion: false,
      dialogCrearOpcion: false,
      crearOpcion: {
        nombre: "",
        descripcion: "",
        descripcionInterna: "",
        loading: false,
      },
      opcionAdd: null,
      fieldEdicionNombreShow: "",
      fieldEdicionOpcionShow: "",
      accion: "configurar",
      editando: false,
      headersBase: [
        {
          width: "15%",
          sortable: false,
        },
        {
          text: "Nombre",
          value: "nombre",
        },
      ],
      modificador: {
        id: null,
        nombre: [],
        descripcion: [],
        descripcionInterna: "",
        tipo: "", //simple, multiple, ultra
        opciones: [],
        max: 0,
        min: 0,
      },
      tipos: [
        {
          value: "simple",
          text: "Simple",
        },
        {
          value: "multi",
          text: "Multiple",
        },
        {
          value: "ultramulti",
          text: "Ultra Multiple",
        },
      ],
    };
  },
  watch: {
    dialogAddOpcion(v) {
      // if (!v) this.opcionAdd = null;

      setTimeout(() => {
        console.log(this.$refs.addOpcionNombre);
        this.$refs.addOpcionNombre.focus();
      }, 300);
    },
    dialogCrearOpcion(v) {
      if (!v) this.crearOpcion.nombre = "";
      setTimeout(() => {
        console.log(this.$refs.crearOpcionNombre);
        this.$refs.crearOpcionNombre.focus();
      }, 300);
    },
  },
  computed: {
    gruposUtilizanModificador() {
      return this.$store.state.productos.gruposModificadores
        .filter((grupo) => {
          return grupo.modificadores
            .map((g) => g.id)
            .includes(this.modificador.id);
        })
        .map((g) => g.nombre)
        .join(", ");
    },
    headers() {
      return [
        ...this.headersBase,
        ...this.tarifas
          .map((t) => {
            return [
              {
                sortable: false,
                text: t.nombre + " Activo",
                value: "activo",
              },
              {
                sortable: false,
                text: t.nombre + " Precio",
                value: "precio",
              },
            ];
          })
          .flat(),
      ];
    },
    tarifasSelect() {
      return this.tarifas.map((t) => {
        return {
          text: t.nombre,
          value: t.id,
        };
      });
    },
    nombrePanel: {
      get() {
        this.langSeleccionado;
        return this.modificador.nombre.length > 0
          ? this.modificador.nombre.find((n) => n.lang == this.langSeleccionado)
              .text
          : "";
      },
      set(v) {
        let f = this.modificador.nombre.findIndex(
          (n) => n.lang == this.langSeleccionado
        );
        if (f > -1) this.modificador.nombre[f].text = v;
      },
    },
    descripcionPanel: {
      get() {
        return this.modificador.descripcion.length > 0
          ? this.modificador.descripcion.find(
              (n) => n.lang == this.langSeleccionado
            ).text
          : "";
      },
      set(v) {
        let f = this.modificador.descripcion.findIndex(
          (n) => n.lang == this.langSeleccionado
        );
        if (f > -1) this.modificador.descripcion[f].text = v;
      },
    },
    nombrePanelLabel() {
      return "Nombre panel " + this.langSeleccionado;
    },
    descripcionPanelLabel() {
      return "Descripción panel " + this.langSeleccionado;
    },
    langSeleccionado: {
      get() {
        return this.$store.state.langSeleccionado;
      },
      set(v) {
        this.$store.commit("setLangSeleccionado", v);
      },
    },
    title() {
      let res = "";
      switch (this.accion) {
        case "configurar":
          res = "Construir producto";
          break;
        case "compatibilidad":
          res = "Manejar compatibilidades";
          break;
        case "mapeo":
          res = "Manejar mapeo Neo";
          break;
      }
      return res;
    },
    isConfigurar() {
      return this.accion !== "configurar";
    },
    ...mapGetters({
      negocio: "app/negocioGestObj",
    }),
    ...mapState({
      idiomas: "idiomas",
      langDefecto: "langDefecto",
      productos: (state) => state.productos.productosArray,
      tarifas: (state) => state.productos.tarifas,
    }),
    modificadores() {
      return this.productos
        .filter((p) => p.modificador)
        .map((p) => {
          return {
            text:
              mostrarIdioma(p.nombre) +
              (p.descripcionInterna ? " - " + p.descripcionInterna : ""),
            value: p.id,
          };
        });
    },
    modificadoresComputed() {
      let modificadores = this.productos.filter((p) => p.modificador);
      let res = this.modificador.opciones
        .map((op) => {
          let found = modificadores.find(
            (mod) => mod.id == op.id.split("_")[0]
          );
          var tarifasDevolver = [];
          if (op.tarifas) {
            tarifasDevolver = this.tarifas.map((t) => {
              let found = op.tarifas.find((tar) => tar.id == t.id); //ya tenía esta tarifa;
              if (found) {
                return {
                  id: found.id,
                  activo: found.activo ? found.activo : false,
                  precio: found.precio ? found.precio : false,
                  aceptarPrecioGlobal: found.aceptarPrecioGlobal
                    ? found.aceptarPrecioGlobal
                    : false,
                };
              } else {
                return {
                  id: t.id,
                  activo: false,
                  precio: 0,
                  aceptarPrecioGlobal: true,
                };
              }
            });
          } else {
            tarifasDevolver = this.tarifas.map((t) => {
              return {
                id: t.id,
                activo: false,
                precio: 0,
                aceptarPrecioGlobal: true,
              };
            });
          }
          return found
            ? {
                ...found,
                nombre: mostrarIdioma(found.nombre),
                ...op,
                tarifas: tarifasDevolver,
              }
            : false;
        })
        .filter((m) => !!m);
      return res;
    },
  },
  methods: {
    marcarDefecto(item) {
      console.log(item);
      console.log(this.modificador);
    },
    async goOpcion(item) {
      await this.save();
      this.$router.push(
        "/admin/gest/" +
          this.negocio.id +
          "/almacen/productos/edit/" +
          item.id.split("_")[0]
      );
    },
    cambiarAsociadoCheckBox(bool, item, tarifa) {
      if (tarifa.activo) {
        tarifa.precio = item.precioGlobal;
      }
    },
    marcarTodos(bool) {
      // this.modificadoresComputed = this.modificadoresComputed.map((mod) => {
      //         return {
      //           ...mod,
      //           tarifas: mod.tarifas.map((t) => {
      //             return {
      //               ...t,
      //               precio: t.activo ? t.precio : mod.precioGlobal,
      //               activo: true,
      //             };
      //           }),
      //         };
      //       });

      this.modificador = {
        ...this.modificador,
        opciones: this.modificador.opciones.map((op) => {
          return {
            ...op,
            tarifas: op.tarifas.map((t) => {
              if (!t.activo) {
                // t.precio =
                let modificadores = this.productos.filter((p) => p.modificador);
                let found = modificadores.find((m) => m.id == op.id);
                t.precio = !!found ? found.precioGlobal : 0;
              }
              return {
                ...t,
                activo: bool,
              };
            }),
          };
        }),
      };
    },
    deleteItem(item) {
      this.$confirm("¿Desea eliminar este modificador?", {
        buttonTrueText: "Aceptar",
        buttonFalseText: "No",
        color: "warning",
        icon: "warning",
        width: 350,
      }).then((res) => {
        if (res) {
          let i = this.modificador.opciones.findIndex((op) => op.id == item.id);
          if (i > -1) {
            this.modificador.opciones.splice(i, 1);
          }
        }
      });
    },
    mostrarIdioma(s) {
      return mostrarIdioma(s);
    },
    addOpcionBoton() {
      this.dialogAddOpcion = true;
    },
    crearOpcionBoton() {
      this.dialogCrearOpcion = true;
    },
    addOpcionConfirmar(id = false) {
      id = id ? id : this.opcionAdd;

      // let f = this.modificador.opciones.filter((op) => op.id == id);
      // id = id + "_" + f.length;
      let agregar = {
        id: id,
        tarifas: this.tarifas.map((t) => {
          return {
            id: t.id,
            activo: true,
            precio: id ? "0" : this.opcionAdd.precioGlobal,
          };
        }),
      };
      console.log(agregar);
      this.modificador.opciones.push(agregar);
      this.dialogAddOpcion = false;
    },
    crearOpcionConfirmar() {
      let agregar = {
        categoria: null,
        caractSeleccionadas: [],
        descripcion: this.idiomas.map((l) => {
          return {
            lang: l.value,
            text:
              l.value == this.langDefecto ? this.crearOpcion.descripcion : "",
          };
        }),
        descripcionInterna: this.crearOpcion.descripcionInterna,
        nombre: this.idiomas.map((l) => {
          return {
            lang: l.value,
            text: l.value == this.langDefecto ? this.crearOpcion.nombre : "",
          };
        }),
        tieneOpciones: false,
        precioGlobal: 0,
        ocultarImagen: false,
        modificador: true,
        individualPedible: false,
      };
      console.log(agregar);
      this.crearOpcion.loading = true;
      var idAgregar;
      return this.$store
        .dispatch("productos/addProducto", agregar)
        .then((r) => {
          console.log(r);
          idAgregar = r.id;
          return this.$store.dispatch("productos/getProductos");
        })
        .then(() => {
          this.addOpcionConfirmar(idAgregar);
        })
        .then(() => (this.dialogCrearOpcion = false))
        .catch((e) => console.log(e))
        .finally(() => {
          this.crearOpcion.loading = false;
        });
    },
    goBack() {
      this.$router.go(-1);

      // let str = "/admin/gest/" + this.negocio.id + "/almacen/modificadores";
      // this.$router.push(str);
    },
    save() {
      this.loadingGuardar = true;
      this.loading = true;
      this.modificador.opciones = this.modificadoresComputed.map((m) => {
        return {
          id: m.id,
          tarifas: m.tarifas,
        };
      });
      this.$store
        .dispatch("productos/addModificador", this.modificador)
        .then(() => {
          this.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Modificador guardado",
          });
          if (!this.modificador.id) this.goBack();
        })

        .catch((error) => {
          console.log(error);
          this.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al actualizar el modificador: " + error,
          });
        })
        .finally(() => {
          this.loadingGuardar = false;
          this.loading = false;
        });
    },
    dragReorder({ oldIndex, newIndex }) {
      const movedItem = this.modificador.opciones.splice(oldIndex, 1)[0];
      this.modificador.opciones.splice(newIndex, 0, movedItem);
    },
    itemKey(item) {
      if (!this.itemKeys.has(item))
        this.itemKeys.set(item, ++this.currentItemKey);
      return this.itemKeys.get(item);
    },
  },
  mounted() {
    new Sortable(
      this.$refs.sortableTable.$el.getElementsByTagName("tbody")[0],
      {
        draggable: ".sortableRow",
        handle: ".sortHandle",
        onEnd: this.dragReorder,
      }
    );

    if (this.$route.params.id) {
      //obtenemos modificador
      this.$store
        .dispatch("productos/getModificador", this.$route.params.id)
        .then((r) => {
          this.modificador = { ...r, id: this.$route.params.id };
          if (
            !Array.isArray(this.modificador.nombre) ||
            this.modificador.nombre.length == 0
          ) {
            this.modificador.nombre = [];
            this.modificador.descripcion = [];
            this.idiomas.forEach((lang) => {
              this.modificador.nombre.push({
                lang: lang.value,
                text: "Panel " + lang.text,
              });
              this.modificador.descripcion.push({
                lang: lang.value,
                text: "Descripción " + lang.text,
              });
              this.tipo = "simple";
            });
          }
        });
    } else {
      this.idiomas.forEach((lang) => {
        this.modificador.nombre.push({
          lang: lang.value,
          text: "Panel " + lang.text,
        });
        this.modificador.descripcion.push({
          lang: lang.value,
          text: "Descripción " + lang.text,
        });
        this.tipo = "simple";
      });
    }
  },
};
</script>

<style>
</style>